module.exports = __webpack_public_path__ + "img/partner_not_found.6154932a.svg";